// @ts-nocheck
import React from 'react';
import { Download } from 'lucide-react';
import { buildRecordingAudioUrl, buildVoicemailAudioUrl, isMediaReady, MEDIA_NOT_READY_TITLE } from '@/utilities/cdrMedia';
import { storageUrlOr } from '@/utilities/storageUrl';

export const mediaUrl = (item) => {
  if (!isMediaReady(item)) return null;
  const isRecording = item?.kind === 'recording';
  return storageUrlOr(
    isRecording ? 'recordings' : 'voicemails',
    item?.blob_path,
    isRecording ? buildRecordingAudioUrl(item?.id) : buildVoicemailAudioUrl(item?.id),
  );
};

const pauseOthers = (e) =>
  document.querySelectorAll('audio').forEach((a) => a !== e.currentTarget && a.pause());

export default function MediaAudioList({ media = [], compact = false }: any) {
  if (!media.length) return <span className="text-muted-foreground">-</span>;
  return (
    <div className="flex flex-col gap-1.5" onClick={(e) => e.stopPropagation()}>
      {media.map((item) => {
        const url = mediaUrl(item);
        const label = item?.kind === 'recording' ? 'Rec' : 'VM';
        return (
          <div key={`${item?.kind}-${item?.id}`} className="flex items-center gap-2 text-[11px] text-muted-foreground">
            {compact ? null : <span className="w-8 shrink-0 font-medium">{label}</span>}
            {url ? (
              <>
                <audio
                  controls
                  preload="none"
                  src={url}
                  onPlay={pauseOthers}
                  title={item?.name || label}
                  className={compact ? 'h-8 w-[300px] max-w-none shrink-0' : 'h-9 w-full max-w-md'}
                />
                <a href={url} download={item?.name || ''} className="hover:text-foreground" title="Download">
                  <Download className="h-3.5 w-3.5" />
                </a>
              </>
            ) : (
              <span title={MEDIA_NOT_READY_TITLE}>{label} not ready yet</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
